
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class KaratRateSelectGrid extends Serenity.EntityGrid<KaratRateRow, any> {
        protected getColumnsKey() { return 'OMS.KaratRate'; }
        protected getDialogType() { return <any>KaratRateDialog; }
        protected getIdProperty() { return KaratRateRow.idProperty; }
        protected getLocalTextPrefix() { return KaratRateRow.localTextPrefix; }
        protected getService() { return KaratRateService.baseUrl; }
        //protected getInsertPermission() { return KaratRateRow.insertPermission; }
        //protected getUpdatePermission() { return KaratRateRow.updatePermission; }
        //protected getDeletePermission() { return KaratRateRow.deletePermission; }
        //protected useViewMode() { return true; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            return this;
        }

        get selectedItems(): KaratRateRow[] {
                var _this = this;
                return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideRates && this.options.hideRates.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["RateID" /* RateID */], 'not in', [this.options.hideRates]]);
            return true;
           
        }
        
    }

    export interface RateSelectOptions {
        ParentKey?: string;
        Key?: string;
        Title?: string;
        IsGroup?: boolean;
        GrantRevoke?: boolean;
    }
}